import React from 'react'
import { Redirect } from 'react-router-dom'

const renderWhen = (predicate: boolean, WrappedComponent: React.ComponentType) => (props: any) =>
  predicate ? <WrappedComponent {...props} /> : <Redirect to='/' />

export default renderWhen
